import { SoundOutWordsPage } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { SpellableWordProps } from 'state/providers/SoundOutWordsProvider/types';
import { getWordAndPunctuation } from 'util/get-words-and-punctuation';

type WordPosition = {
  currentDataIndex: number;
  wordIndexOnPage: number;
  word: string;
};

const getSpellableWord = (
  currentData: SoundOutWordsPage,
  word: string,
  order: number,
  wordIndexOnPage: number
): SpellableWordProps | undefined => {
  const { wordToDisplay: currentWordWithoutPunctuation } = getWordAndPunctuation(word);

  const foundWord = currentData.words?.find(
    (wordToSpell) =>
      wordToSpell?.sounds &&
      currentWordWithoutPunctuation.toLowerCase() === wordToSpell.word.description
  );

  return foundWord
    ? ({
        description: foundWord?.word.description,
        sounds: foundWord?.sounds,
        capitalize: foundWord?.word.capitalize,
        order,
        page: currentData.page?.pageNumber,
        wordIndexOnPage,
      } as SpellableWordProps)
    : undefined;
};

export const getOrderedWords = (currentData: SoundOutWordsPage[]): SpellableWordProps[] => {
  const wordPositionsOfPages = currentData.reduce((acc: WordPosition[], curr, currentDataIndex) => {
    const pageWordPositions: WordPosition[] = `${curr.contents?.description}`
      .split(' ')
      .map((word, wordIndexOnPage) => ({
        currentDataIndex,
        wordIndexOnPage,
        word,
      }));

    return [...acc, ...pageWordPositions];
  }, []);

  const orderedWords = wordPositionsOfPages.reduce((acc, wordPosition, order) => {
    const word = getSpellableWord(
      currentData[wordPosition.currentDataIndex],
      wordPosition.word,
      order,
      wordPosition.wordIndexOnPage
    );
    if (word && word.sounds) {
      return [...acc, word as SpellableWordProps];
    }
    return acc;
  }, [] as SpellableWordProps[]);

  return orderedWords;
};
